import React from 'react';
import { useTranslation } from 'react-i18next';


import "./easyIntegration.scss";

//Imagens:
import ImgeasyIntegration from "../../../../assets/dataManagement/easyIntegration.png";

function EasyIntegration() {
    const { t } = useTranslation()

    return (
        <div className='container-easy-integration'>
            <div className='img-easy-integration'>
                <img src={ImgeasyIntegration} alt="" />
            </div>
            <div className='texts-easy-integration'>
                <h1>{t("datasources.easy_integration.title")}</h1>
                <p>{t("datasources.easy_integration.section_text_1")}</p>
                <p>{t("datasources.easy_integration.section_text_2")}</p>
            </div>
        </div>
    )
}

export default EasyIntegration;